import { render } from "./LbrxListCustomers.vue?vue&type=template&id=7fb78081&scoped=true"
import script from "./LbrxListCustomers.vue?vue&type=script&lang=js"
export * from "./LbrxListCustomers.vue?vue&type=script&lang=js"

import "./LbrxListCustomers.vue?vue&type=style&index=0&id=7fb78081&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb78081"]])

export default __exports__